<template>
    <v-card outlined v-bind="{ loading }">
        <v-card-title>
            <v-row no-gutters align="center">
                <v-col cols="auto">
                    <span> {{ typeText }} 매출 </span>
                </v-col>
                <v-spacer />
                <v-col cols="auto" class="my-n2">
                    <v-date-field v-model="date" :type="{ day: 'date', month: 'month' }[type]" :label="`매출${typeText}`" persistent-placeholder hide-details @input="search" />
                </v-col>
            </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text>
            <v-row align="center">
                <template v-for="item in items">
                    <v-col :key="item.title" cols="6" sm="4" md="3" lg="2" class="text-center">
                        <v-card outlined>
                            <v-row class="flex-column ma-0">
                                <v-col class="text-h6">{{ item.title }}</v-col>
                                <v-divider />
                                <v-col class="text-h6 font-weight-bold">{{ item.value }}</v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </template>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import api from "@/api";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";

export default {
    components: {
        VDateField,
    },
    props: {
        type: { type: String, default: "day" },
    },
    data() {
        return {
            date: {
                day: this.$dayjs().format("YYYY-MM-DD"),
                month: this.$dayjs().format("YYYY-MM"),
            }[this.type],

            loading: false,

            summary: {
                total: 0,
                monthTotal: 0,
                galaxiaTotal: 0,
                cultureland2Total: 0,
                paysTotal: 0,
                danalTotal: 0,
                happymoneyBulckTotal: 0,
                paysBulckTotal: 0,
                toppingTotal: 0,
                payletterTotal: 0,
                tscientificTotal: 0,
                baroconTotal: 0,
                chlifesTotal: 0,
            },
        };
    },
    computed: {
        typeText() {
            return {
                day: "일",
                month: "월",
            }[this.type];
        },
        items() {
            return [
                //
                {
                    title: { day: "당일 총 매출", month: "당월 총 매출" }[this.type],
                    value: this.summary?.total?.format?.(),
                },
                {
                    title: "갤럭시아",
                    value: this.summary?.galaxiaTotal?.format?.(),
                },
                {
                    title: "한국문화진흥",
                    value: this.summary?.cultureland2Total?.format?.(),
                },
                {
                    title: "페이즈",
                    value: this.summary?.paysTotal?.format?.(),
                },
                {
                    title: "다날",
                    value: this.summary?.danalTotal?.format?.(),
                },
                {
                    title: "해피머니",
                    value: this.summary?.happymoneyBulckTotal?.format?.(),
                },
                {
                    title: "도서문화상품권",
                    value: this.summary?.paysBulckTotal?.format?.(),
                },
                {
                    title: "토핑",
                    value: this.summary?.toppingTotal?.format?.(),
                },
                {
                    title: "캐시박스",
                    value: this.summary?.payletterTotal?.format?.(),
                },
                {
                    title: "티사이언티픽",
                    value: this.summary?.tscientificTotal?.format?.(),
                },
                {
                    title: "더블엔씨",
                    value: this.summary?.baroconTotal?.format?.(),
                },
                {
                    title: "클라이프스",
                    value: this.summary?.chlifesTotal?.format?.(),
                },
            ];
        },
    },
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { type, date } = this;
                let { summary } = await api.console.dashboard.get({
                    headers: { type },
                    params: { date },
                });
                this.summary = summary;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style></style>
